import axios from 'axios';
import { CPO_API } from '../config';

const BASE_URL = CPO_API;
const VALIDATE_VOUCHER_URL = `${BASE_URL}/donation/vouchers/validate`;
const CONSUME_VOUCHER_URL = `${BASE_URL}/donation/vouchers/consume`;

const validateVoucher = (code) => {
  const payload = { code };
  return axios.post(VALIDATE_VOUCHER_URL, payload);
};

const consumeVoucher = ({ code, donor, firstName, lastName, phone, email }) => {
  const payload = {
    code,
    donor,
    firstName,
    lastName,
    phone,
    email,
    autoClaim: true
  };
  return axios.post(CONSUME_VOUCHER_URL, payload);
};

export { validateVoucher, consumeVoucher };
